'use client'

import { useEffect, useState } from 'react'
import { linkClass } from 'app/components/styles'
import { useRouter, usePathname } from 'next/navigation'
import TrackedLink from 'app/components/tracked-link'
import { track404Redirect, trackEvent } from 'app/components/analytics'

export default function NotFound() {
  const [countdown, setCountdown] = useState(9)
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    document.title = '404 Not Found | Sandeep Baskaran'
    const sectionEl = document.getElementById('mobile-header-section')
    if (sectionEl) {
      sectionEl.textContent = '404 Not Found'
    }
    
    // Track 404 page hit immediately
    trackEvent('404_not_found', {
      attempted_url: pathname || '/unknown',
    })
  }, [pathname])

  useEffect(() => {
    if (countdown === 0) {
      track404Redirect(pathname || '/unknown')
      router.push('/')
      return
    }

    const timer = setTimeout(() => {
      setCountdown(countdown - 1)
    }, 1000)

    return () => clearTimeout(timer)
  }, [countdown, router, pathname])

  return (
    <section>
      <h1 className="mb-8 text-2xl font-semibold tracking-tighter">
        Oops! You're not supposed to be here.
      </h1>
      <p className="mb-4 text-[var(--text-secondary)]">
        This page doesn't exist, got lost, or maybe never did.
      </p>
      <p className="text-[var(--text-secondary)]">
        <TrackedLink
          href="/"
          name="404_home_link"
          className={linkClass}
        >
          Go to home page
        </TrackedLink>
        <span className="ml-2">(Or I'll take you there in {countdown} second{countdown !== 1 ? 's' : ''})</span>
      </p>
    </section>
  )
}
